export const getWithdrawTimingMessage = (settings = {}) => {
  const open = settings.withdrawOpenTime || "--";
  const close = settings.withdrawCloseTime || "--";
  return `Withdrawal is available from ${open} to ${close}.`;
};

export const parseWithdrawTime = (timeStr) => {
  if (!timeStr || typeof timeStr !== "string") return null;

  const normalized = timeStr.trim();
  const meridianMatch = normalized.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)$/i);
  if (meridianMatch) {
    let hours = Number(meridianMatch[1]);
    const minutes = Number(meridianMatch[2]);
    const meridian = meridianMatch[3].toUpperCase();

    if (meridian === "PM" && hours < 12) hours += 12;
    if (meridian === "AM" && hours === 12) hours = 0;

    return { hours, minutes };
  }

  const twentyFourHourMatch = normalized.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (twentyFourHourMatch) {
    return {
      hours: Number(twentyFourHourMatch[1]),
      minutes: Number(twentyFourHourMatch[2]),
    };
  }

  return null;
};

export const isWithinWithdrawTime = (settings = {}, now = new Date()) => {
  if (settings.withdrawStatus === false || settings.withdrawStatus === "false") {
    return false;
  }

  const open = parseWithdrawTime(settings.withdrawOpenTime);
  const close = parseWithdrawTime(settings.withdrawCloseTime);
  if (!open || !close) return true;

  const openTime = new Date(now);
  openTime.setHours(open.hours, open.minutes, 0, 0);

  const closeTime = new Date(now);
  closeTime.setHours(close.hours, close.minutes, 0, 0);

  if (closeTime < openTime) {
    return now >= openTime || now <= closeTime;
  }

  return now >= openTime && now <= closeTime;
};

export const readStoredFeeSettings = () => {
  try {
    const settingsString = localStorage.getItem("feeSettings");
    if (!settingsString) return {};

    const settings = JSON.parse(settingsString);
    return settings && typeof settings === "object" ? settings : {};
  } catch {
    return {};
  }
};
